/**
 * @generated SignedSource<<869105ef4df5535ef510a3279842907d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StickySubscribeButtonFragment$data = {
  readonly id: string;
  readonly threadSubscriptionChannel: string | null | undefined;
  readonly " $fragmentType": "StickySubscribeButtonFragment";
};
export type StickySubscribeButtonFragment$key = {
  readonly " $data"?: StickySubscribeButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"StickySubscribeButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StickySubscribeButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "threadSubscriptionChannel",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "801aadfbcfcc97f90fee0ea72153695c";

export default node;
